import { render, staticRenderFns } from "./SelectedDoctorsWS.vue?vue&type=template&id=1cf459e4&scoped=true"
import script from "./SelectedDoctorsWS.vue?vue&type=script&lang=js"
export * from "./SelectedDoctorsWS.vue?vue&type=script&lang=js"
import style0 from "./SelectedDoctorsWS.vue?vue&type=style&index=0&id=1cf459e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf459e4",
  null
  
)

export default component.exports